<template>
  <div>
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
      <a-form-model
        ref="ruleForm"
        layout="inline"
        :model="formInline"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-row>
          <a-col :span="6">
            <a-form-model-item label="角色名称" prop="user">
              <a-input v-model="formInline.roleName" placeholder="请输入">
                <a-icon
                  slot="prefix"
                  type="user"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item>
              <a-button type="primary" html-type="submit"> 查询 </a-button>
            </a-form-model-item>
            <a-form-model-item>
              <a-button style="margin-left: 10px" @click="resetForm">
                重置
              </a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>

    <a-layout-content style="margin: 0 16px">
      <div :style="{ padding: '24px', background: '#fff', minHeight: '360px' }">
        <partManagementHomeContentTwo
          ref="aaa"
          :formInline="formInline"
        ></partManagementHomeContentTwo>
      </div>
    </a-layout-content>
    <!-- <memberManagementContent></memberManagementContent> -->
  </div>
</template>

<script>
import partManagementHomeContentTwo from "./partManagementHomeContentTwo.vue";
export default {
  components: {
    partManagementHomeContentTwo,
  },
  data() {
    return {
      formInline: {
        roleName: "",
        limit: 10,
        page: 1,
      },
    };
  },
  methods: {
    handleSubmit(e) {
      console.log(this.formInline);
      this.$refs.aaa.query();
    },
    resetForm() {
      this.$refs.aaa.getStorePermissionsList();
      this.formInline = {};
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/right/partManagementTwo/partManagementHomeTwo.vue